<script>
export default {
  methods: {
    historyBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<template>
  <span class="icon chevron-left back-arrow" @click="historyBack">
    <i class="c-icon is-cs-2 cachalog-chevron"></i>
  </span>
</template>



// WEBPACK FOOTER //
// src/components/design/back-arrow.vue